import React, {Fragment} from "react";
import "../../scss/CustomerIndex.css"
import ToastHelper from "../../utils/ToastHelper";
import AgentService from "../../services/Agent/AgentService";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import LoadingSpinnerComponent from "../../components/LoadingSpinnerComponent";
import ValidatableObjectComponent from "../../components/ValidatableObjectComponent";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import * as Yup from "yup";

export default class AgentContactView extends React.Component {

    constructor(props) {
        super(props);
        this.contactValidationConfig = [
            {
                dataField: "id", dataLabel: "Id", hideOnCreate: true, createValue: 0,
                readOnly: true,
                yup: Yup.string()
                    .required('Id is required')
            },
            {
                dataField: "contactType",
                dataLabel: "Contact Type",
                type: "select",
                selectOptions: [{value: "MSISDN", text: "Cellphone Number"}, {value: "EMAIL", text: "Email"}],
                yup: Yup.string()
                    .required('Contact Type is required')
            },
            {
                dataField: "contactValue", dataLabel: "Contact Value",
                yup: Yup.string()
                    .required('Contact value is required')
            },
            {
                dataField: "contactName", dataLabel: "Contact Name",
                yup: Yup.string()
                    .required('Contact Name is required')
            },
            {
                dataField: "primary", dataLabel: "Is Primary",
                type: "switch",
                trueLabel: "True",
                falseLabel: "False",
                switchColour: "success",
                yup: Yup.string()
                    .required("Active must have a value set")
            }
        ];

        this.viewRef = {};

        this.state = {
            isAddPopupOpen: false,
            loading: false
        }
    }

    loadData() {
        AgentService.retrieveByUserId(this.userId).then(response => {
            if (response.id) {
                this.setState({
                    loading: false,
                    agentData: response,
                });
            } else {
                ToastHelper.error(response);
            }
        });
    }

    submit() {
        this.setState({loading: true})
        let newValues = this.viewRef.getValues();
        let newState = {loading: false}
        AgentService.updateContact(this.props.agentId, newValues).then(response => {
            if (response.id) {
                newState.loading = false
                newState.isPopupOpen = false
                newState.detailsValid = false;

                ToastHelper.success("Contact details updated.");
            } else {
                ToastHelper.formatError(response);
            }
            this.setState(newState, this.props.onRefresh);
        });
    }

    toggleModal() {
        this.setState({isPopupOpen: !this.state.isPopupOpen, detailsValid: false})
    };

    render() {
        let contact = this.props.contact;
        let title = contact.contactType === "MSISDN" ? "Phone Number" : "Email Address ";

        return <div className={"sideBySide"}>
            <span>
                <b>{title}</b> &nbsp;
                {contact.contactValue} &nbsp;
                {contact.primary &&
                    <span style={{color: "green", fontSize: "10pt"}}><i className={"fa fa-check"}/></span>}
            </span>

            {
                this.props.canEdit && <span className={"headerIconStyle"} onClick={this.toggleModal.bind(this)}><i
                    className={"fa fa-edit"}/></span>
            }


            {this.state.isPopupOpen && this.showAddModal()}
        </div>

    }

    showAddModal() {
        return <Fragment>
            <Modal isOpen={this.state.isPopupOpen}
                   className={'modal-primary modal-md'}>
                <ModalHeader toggle={this.toggleModal.bind(this)}>Update Contact</ModalHeader>
                <ModalBody>
                    {this.state.loading
                        ? <LoadingSpinnerComponent/>
                        : <ValidatableObjectComponent
                            ref={(ref) => (this.viewRef = ref)}
                            config={this.contactValidationConfig}
                            defaultValues={this.props.contact}
                            readOnly={false}
                            hideCreateFields={true}
                            onValidChanged={(valid) => {
                                this.setState({
                                    detailsValid: valid
                                })
                            }}
                        />}
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent className="btn btn-block btn-primary"
                                        disabled={this.state.loading || !this.state.detailsValid}
                                        onClick={this.submit.bind(this)}>Submit</SFXButtonComponent>{' '}
                </ModalFooter>
            </Modal>
        </Fragment>
    }
}
